import { FC, useEffect, useRef, useState } from 'react';
import { backButton } from '@telegram-apps/sdk-react';

import Banner from '@/components/Messanger/Chat/Banner/Banner.tsx';
import ChatContent from '@/components/Messanger/Chat/ChatContent/ChatContent.tsx';
import { messengerContainerStyle } from '@/pages/Messenger/styles.ts';
import Modal from '@/animations/Modal.tsx';
import PaywallPopup from '@/components/Popup/PaywallPopup/PaywallPopup.tsx';
import Guard from '@/components/Guard/Guard.tsx';
import { PaywallTypes, ProductInvoicePlacements } from '@/enums/apiEnums.ts';

const Messenger: FC = () => {
  const [payWallOpen, setPayWallOpen] = useState<boolean>(false);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const closePayWall = () => setPayWallOpen(false);
  const openPayWall = () => setPayWallOpen(true);

  useEffect(() => {
    if (backButton.isVisible()) {
      backButton.hide();
    }
  }, []);

  return (
    <Guard component="messenger">
      <div
        ref={scrollContainerRef}
        style={{
          ...messengerContainerStyle,
          overflowY: 'auto',
          height: 'calc(100vh - 180px)',
          marginTop: '100px',
          overscrollBehavior: 'none'
        }}
      >
        <Modal fullScreen open={payWallOpen} handleClose={closePayWall}>
          <PaywallPopup
            handleClose={closePayWall}
            type={PaywallTypes.TYPE_ONE_TIME}
            placement={ProductInvoicePlacements.DIALOGS_HEADER_GET_REACTIONS}
          />
        </Modal>
        <Banner openPayWall={openPayWall} />
        <ChatContent scrollContainerRef={scrollContainerRef} />
      </div>
    </Guard>
  );
};

export default Messenger;
